import React from 'react'
import PublicTournament from "../tournaments/PublicTournament";
import PublicTournamentNeu from "./PublicTournamentNeu";
import AnsichtWechselKnopf from "./AnsichtWechselKnopf";
import {useOeffentlicheAnsicht} from "../../../../util/oeffentlicheAnsichtZugriff";

/**
 * Entscheidet, ob die alte oder die neue öffentliche Turnieransicht angezeigt wird.
 * Der Wechsel über den Knopf oben rechts wird dauerhaft im Browser gemerkt.
 */
export default function PublicTournamentAnsicht(props) {

    const ansicht = useOeffentlicheAnsicht();

    return <AnsichtWechselKnopf neueAnsicht={ansicht.neueAnsicht} onWechseln={ansicht.wechseln}>
        {ansicht.neueAnsicht ? <PublicTournamentNeu {...props}/> : <PublicTournament {...props}/>}
    </AnsichtWechselKnopf>
}
